import { Department } from "./types"

type DepartmentJobListingProps = {
  department: Department
}

export const DepartmentJobListing = ({
  department,
}: DepartmentJobListingProps) => {
  return (
    <details className="job-panel border-b border-black-30 first:border-t cursor-pointer">
      <summary className="button--wide group leading-tight text-lg font-heading font-medium py-20 text-left">
        <div className="flex justify-between items-center">
          {department.name}&nbsp;({department.numOfJobs})
          <svg
            aria-hidden="true"
            aria-labelledby="chevron-down"
            className="h-12 w-12 transform duration-200 transition-transform translate -translate-y-1 motion-safe:group-hover:animate-bounce-y-down"
            focusable="false"
            height="9"
            role="img"
            viewBox="0 0 10 8"
            width="10"
            xmlns="http://www.w3.org/2000/svg"
          >
            <title id="chevron-down${dep.name}">Down chevron</title>
            <path
              clipRule="evenodd"
              d="m1.17917.844971 3.82083 3.901729 3.82083-3.901729 1.17917 1.204129-5 5.10587-5-5.10587z"
              fillRule="evenodd"
            ></path>
          </svg>
        </div>
      </summary>
      <ul className="mb-24">
        {department.jobs.map(job => (
          <li key={job.id} className="hover:bg-tan px-24 py-16">
            <a
              className="flex group items-center justify-between"
              target="_blank"
              href={job.absolute_url}
              rel="noreferrer"
            >
              <div>
                <p className="text-16 mr-[14px]">{job.title}</p>
                <p className="text-10 uppercase font-semibold text-black-50 mt-6">
                  {job.location.name}
                </p>
              </div>
              <div className="button button--primary desktop:invisible group-hover:visible group-focus:visible">
                Apply
                <span className="ml-8" aria-hidden="true">
                  →
                </span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </details>
  )
}
